import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import { config } from '../../constants';



export default class CompanyItemComponent extends React.Component{
    
    

    render(){
        
        return(
            <div className='index-list-item'>
                
                <p style={{width:"10%"}}>{this.props.data.id}</p>
                <p style={{width:"20%"}}>{this.props.data.name}</p>

                <div className='config-buttons'>
                    <a href={"/update-company/" + this.props.data.id} className='config-btn config-edit-btn'>/</a>
                </div>

            </div>
        );
    }
}